<template>
  <!-- 选择服务商 -->
  <div>
    选择服务商：
    <el-select
      style="width: 220px"
      size="mini"
      clearable
      v-model="selectOperator"
      placeholder="请选择"
      @visible-change="openSelectOperator"
      @change="changeOperator"
    >
      <el-option
        v-for="item in options"
        :key="item.operator_id"
        :label="item.operator_name"
        :value="item.operator_id"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  name: "selsec-operator",
  data() {
    return {
      options: [], // 服务商选项
      selectOperator: [], // 选择后的服务商
    };
  },
  methods: {
    changeOperator() {
      this.$emit("changeOperator", this.selectOperator);
    },
    openSelectOperator() {
      this.$http.get(`/product/get_operator_list`).then((res) => {
        this.options = res.data.data;
      });
    },
  },
};
</script>

<style>
</style>